<template lang="pug">
article.post-card.--media(
  :id="`post-${post.id}`",
  :class="{ '--focus': isFocus }",
  @click="gotoPost",
) 
  .post-card__wrapper
    
    .post-card__image(
      :style="`background-image: url(${post.img})`"
    )

    .post-card__content
      post-title.post-card__title(
        :post="post"
        link
        @focus="isFocus = true"
        @blur="isFocus = false"
      )
      p.post-card__image-caption {{ post.tagline }}
    
    post-card-footer(
      :post="post"
      :author="author"
    )
</template>

<script>
import PostResourceMixin from '@/mixins/postResource'
import PostTitle from '@/components/post/post-title'
import PostCardFooter from './post-card__footer'

export default {
  name: 'post-card',
  components: {
    PostTitle,
    PostCardFooter,
  },
  mixins: [PostResourceMixin],
  data() {
    return {
      isFocus: false,
    }
  },
}
</script>

<style lang="sass">
.post-card.--media
  .post-card__wrapper
    border-bottom: var(--post-card-accent-border-width) solid var(--accent-color)

  .post-card__image
    padding-bottom: 100%
    border-bottom: none;

  .post-card__content
    position: absolute
    top: 0
    width: 100%
    height: auto

.post-card__image-caption
  display: inline-block
  padding: 0.25rem
  font-size: 0.75rem
  font-style: italic
  float: right
  background-color: hsla(var(--accent-color-h),var(--accent-color-s),var(--accent-color-l), .65)
    
</style>
